import { render, staticRenderFns } from "./CartolaMensual.vue?vue&type=template&id=35b04efc&scoped=true&"
import script from "./CartolaMensual.vue?vue&type=script&lang=ts&"
export * from "./CartolaMensual.vue?vue&type=script&lang=ts&"
import style0 from "./CartolaMensual.vue?vue&type=style&index=0&id=35b04efc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b04efc",
  null
  
)

export default component.exports